"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PixelmonBridgeWrapper;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function PixelmonBridgeWrapper(_ref) {
  var pixelmonInstance = _ref.pixelmonInstance,
      children = _ref.children,
      projectId = _ref.projectId,
      appId = _ref.appId,
      weSdkVersion = _ref.weSdkVersion;

  var _useState = (0, _react.useState)(pixelmonInstance._sessionHistory.firedPixels),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      firedPixels = _useState2[0],
      setFiredPixels = _useState2[1];

  (0, _react.useEffect)(function () {
    var onPixel = function onPixel() {
      setFiredPixels((0, _toConsumableArray2["default"])(pixelmonInstance._sessionHistory.firedPixels));
    };

    pixelmonInstance.on('pixel', onPixel);
    return function () {
      pixelmonInstance.off('pixel', onPixel);
    };
  }, []);

  var _useState3 = (0, _react.useState)(pixelmonInstance._activePixelEvents),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      registeredPixels = _useState4[0],
      setRegisteredPixels = _useState4[1];

  (0, _react.useEffect)(function () {
    var onRegisterPixels = function onRegisterPixels() {
      setRegisteredPixels((0, _toConsumableArray2["default"])(pixelmonInstance._activePixelEvents));
    };

    pixelmonInstance.on('registerpixels', onRegisterPixels);
    return function () {
      pixelmonInstance.off('registerpixels', onRegisterPixels);
    };
  }, []);
  return /*#__PURE__*/_react["default"].cloneElement(children, {
    registeredPixels: registeredPixels,
    firedPixels: firedPixels,
    projectId: projectId,
    appId: appId,
    weSdkVersion: weSdkVersion
  });
}